// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"79":"ea0dcd70","168":"cd0b259c","238":"d42e3e11","239":"d9ada4ab","389":"6ce6911f","456":"9f55ef96","560":"5f08cda7","732":"495ead8b","806":"c6cbeca9","816":"506e62ee","819":"15d29d58","950":"e17fa83f","977":"1c014934"}[chunkId] + ".chunk.js";
};